(function () {
  function updateBuyingOptionDesc(selectedInput) {
    const oneTime = document.querySelector('.buying-option-descriptions #one-time');
    const monthly = document.querySelector('.buying-option-descriptions #subscription-monthly');
    if (!oneTime && !monthly) return;

    const label = selectedInput ? (selectedInput.getAttribute('aria-label') || '') : '';

    if (oneTime) oneTime.classList.toggle('show', label.includes('One-time'));
    if (monthly) monthly.classList.toggle('show', label.includes('Deliver every month'));
  }

  function injectFieldsetLabels(appBlock) {
    const fieldset = appBlock.querySelector('.shopify_subscriptions_fieldset');
    if (!fieldset) return;

    const legend = fieldset.querySelector('label.group_name');
    if (!legend) return;

    const labelText = legend.textContent.trim();

    fieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
      const div = input.nextElementSibling;
      if (!div || div.tagName !== 'DIV') return;

      const firstSpan = div.querySelector('span');
      if (!firstSpan) return;

      const badge = document.createElement('span');
      badge.textContent = labelText;
      firstSpan.insertAdjacentElement('afterend', badge);
    });
  }

  function initSubscriptionToggle() {
    const appBlock = document.querySelector('.shopify_subscriptions_app_block');
    if (!appBlock) return;

    const heading = document.createElement('h2');
    heading.textContent = 'Buying Options';
    appBlock.insertAdjacentElement('beforebegin', heading);

    injectFieldsetLabels(appBlock);

    const checkedInput = appBlock.querySelector('input[type="radio"]:checked');
    updateBuyingOptionDesc(checkedInput);

    appBlock.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') {
        updateBuyingOptionDesc(e.target);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSubscriptionToggle);
  } else {
    initSubscriptionToggle();
  }
})();
